const data = {
  id: 1,
  title: 'Choose the words in the box to fill in the blank.',
  subTitle: 'Chọn từ phù hợp để điền vào ô trống.',
  words: ['go', "free", "watch"],
  questions: ['Hoa:  What do you do in your # time? ', "Quan:  I often # sport programmes on TV. What about you?" , 'Hoa:  I # to the music club with my friends.  '],
  answers: ['free', 'watch','go'],
};

export default data;
